const VIRTUALCREDITCARDDETAIL_UPDATED = (state, VirtualCreditCardDetail) => {
  state.VirtualCreditCardDetail = VirtualCreditCardDetail
}

export default {
  VIRTUALCREDITCARDDETAIL_UPDATED
}
